@if (hasAttachments()) {
<div>
  <mat-list>
    @for (attachment of attachments; track attachment) {
    <mat-list-item class="attachments-list-item">
      @if (isImage(attachment)) {
      <img
        (click)="openImage(attachment)"
        class="attachment-icon"
        [src]="attachment.url"
        [alt]="attachment.name"
      />
      <a
        href="{{ attachment.url }}"
        (click)="$event.preventDefault(); openImage(attachment)"
        >{{ attachment.name }}</a
      >
      } @if (!isImage(attachment)) {
      <mat-icon
        matListIcon
        class="attachment-icon"
        (click)="openAttachment(attachment)"
        >{{ determineIcon(attachment) }}</mat-icon
      >
      <a href="{{ attachment.url }}" target="_blank">{{ attachment.name }}</a>
      }
    </mat-list-item>
    }
  </mat-list>
</div>
} @if (!hasAttachments()) {
<div
  class="
    attachment-empty
    d-flex
    flex-column
    align-items-center
    justify-content-center
  "
>
  <mat-icon>attachment</mat-icon>
  <span>No attachments</span>
</div>
}
